import gapi from 'gapi-client';
import ColorHelper from "./../color"

function SheetHelper() {
    gapi.load('client:auth2', function () {
        console.log("gapi: loaded client")
        gapi.client.init({
            discoveryDocs: ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
            clientId: "931733091200-1s8lk7pkor42gr6l75c51vv1b5pcqg9k.apps.googleusercontent.com",
            scope: ["https://www.googleapis.com/auth/spreadsheets", "https://www.googleapis.com/auth/drive"]
        })

        gapi.client.load('drive', 'v2', function() {})
    })
}

SheetHelper.prototype.copyFile = async function(originFileId, copyTitle) {
    var body = {'title': copyTitle};

    return gapi.client.drive.files.copy({
       'fileId': originFileId,
       'resource': body
     }).then((response) => {
       return gapi.client.sheets.spreadsheets.get({spreadsheetId: response.result.id})
           .then(response => response.result);
     })
}

SheetHelper.prototype.get = function (config = {}) {
  let {
      spreadsheetId,
      range
  } = config
  return gapi.client.sheets.spreadsheets.get(config)
      .then(response => response.result);
}

SheetHelper.prototype.clear = function (config = {}) {
  let {
      spreadsheetId,
      range
  } = config
  return gapi.client.sheets.spreadsheets.values.clear({
          spreadsheetId,
          range: range || "A:XX"
      })
      .then(response => response.result)
}

SheetHelper.prototype.create = function (config = {}) {
  let {
      title,
      sheets,
      spreadsheetId
  } = config

  return gapi.client.sheets.spreadsheets.create({}, {
      spreadsheetId: spreadsheetId,
      properties: {
          title: title || new Date().toString(),
          locale: 'en_US'
      },
      sheets: sheets
  }).then(response => response.result)
}

SheetHelper.prototype.update = function (spreadsheet, config = {}) {
  let {
      spreadsheetId
  } = spreadsheet
  let {
      requests
  } = config
  return gapi.client.sheets.spreadsheets.batchUpdate({
          spreadsheetId: spreadsheetId,
      }, {
          requests: requests
      })
      .then(response => response.result)
}


SheetHelper.prototype.copyTo = function (config = {}) {
  let {
      spreadsheetId,
      sheetId,
      destinationSpreadsheetId
  } = config

  return gapi.client.sheets.spreadsheets.sheets.copyTo({
      spreadsheetId: spreadsheetId,
      sheetId: sheetId,
      resource: {
        destinationSpreadsheetId: destinationSpreadsheetId
      },
  }).then(response => response.result)
}


SheetHelper.prototype.createSection = async function (spreadsheet, config = {}, ) {
  let {title, rows = [], columns = [], header = {}, y = 0} = config

  let height = rows.length + 2
  let width = rows.reduce((prev, curr) => {
      if (curr.values.length > prev) return curr.values.length
      else return prev
  }, 0)

  if (header.values && header.values.length + 1 > width) width = header.values.length + 1


  if (header.type === "list"){
      header.backgroundColor = "#6B9BA6"
      header.height = 26
  }

  if (header.type === "big-list"){
      header.backgroundColor = "#6B9BA6"
      header.height = 56
      header.fontSizeTitle = 14
  }

  if (header.type === "time-series"){
      header.backgroundColor = "#3C7683"
      header.height = 84
      header.fontSizeTitle = 10
      header.angleHeadings = 90
      header.boldTitle = true
      header.colorTitle = "#ffffff"
      header.horizontalAlignmentHeadings = "RIGHT"
      header.verticalAlignmentHeadings = "MIDDLE"
  }

  header = {
      height: header.height || 26,
      backgroundColor: header.backgroundColor || "#3C7683",
      colorTitle: header.colorTitle || "#000000",
      fontSizeTitle: header.fontSizeTitle || 10,
      boldTitle: header.boldTitle || false,
      angleHeadings: header.angleHeadings || 0,
      fontSizeHeadings: header.fontSizeHeadings || 10,
      boldHeadings: header.boldHeadings || false,
      colorHeadings: header.colorHeadings || "#000000",
      horizontalAlignmentHeadings: header.horizontalAlignmentHeadings || "LEFT",
      verticalAlignmentHeadings: header.verticalAlignmentHeadings || "BOTTOM",
      values: header.values || []
  }


  //Create Header
  let sheetId = spreadsheet.sheets[0].properties.sheetId
  await this.writeRow(spreadsheet, {
      values: [`  ${title}`, ...header.values],
      y: y
  })

  await this.update(spreadsheet, {
      requests: [{
          repeatCell: {
              range: {
                  sheetId: sheetId,
                  startRowIndex: y - 1,
                  endRowIndex: y,
                  startColumnIndex: 1,
                  endColumnIndex: width + 1
              },
              cell: {
                  userEnteredFormat: {
                      backgroundColor: ColorHelper.hexToRGB(header.backgroundColor),
                      horizontalAlignment: "LEFT",
                      verticalAlignment: "MIDDLE",
                      textFormat: {
                          foregroundColor: ColorHelper.hexToRGB(header.colorTitle),
                          fontSize: header.fontSizeTitle,
                          bold: header.boldTitle
                      }
                  }
              },
              fields: "userEnteredFormat(backgroundColor,textFormat,horizontalAlignment, verticalAlignment)"
          }
      },
      {
          repeatCell: {
              range: {
                  sheetId: sheetId,
                  startRowIndex: y - 1,
                  endRowIndex: y,
                  startColumnIndex: 2,
                  endColumnIndex: width + 1
              },
              cell: {

                  userEnteredFormat: {
                      textRotation: {
                          angle: header.angleHeadings,
                      },
                      horizontalAlignment: header.horizontalAlignmentHeadings,
                      verticalAlignment: header.verticalAlignmentHeadings,
                      textFormat: {
                          fontSize: header.fontSizeHeadings,
                          bold: header.boldHeadings
                      }
                  }
              },
              fields: "userEnteredFormat(textRotation, textFormat, horizontalAlignment, verticalAlignment)"
          }
      },
      {
          "updateDimensionProperties": {
              "range": {
                  "sheetId": sheetId,
                  "dimension": "ROWS",
                  "startIndex": y - 1,
                  "endIndex": y
              },
              "properties": {
                  "pixelSize": header.height
              },
              "fields": "pixelSize"
          }
      },
      {
          "updateDimensionProperties": {
              "range": {
                  "sheetId": sheetId,
                  "dimension": "COLUMNS",
                  "startIndex": 1,
                  "endIndex": 2
              },
              "properties": {
                  "pixelSize": 300
              },
              "fields": "pixelSize"
          }
      },
      {
          "updateDimensionProperties": {
              "range": {
                  "sheetId": sheetId,
                  "dimension": "COLUMNS",
                  "startIndex": 0,
                  "endIndex": 1
              },
              "properties": {
                  "pixelSize": 45
              },
              "fields": "pixelSize"
          }
      }]
    })

    let requests = []

    await this.writeRows(spreadsheet, {
      values: rows.map(row => row.values),
      y: y + 1
    })

    await Promise.all(rows.map(async (row, i) => {
      let color, backgroundColor;
      //let {bold = false, fontSize = 14} = row
      let {bold = false, fontSize = 10} = row
      color = ColorHelper.hexToRGB("#000000")
      backgroundColor = ColorHelper.hexToRGB("#FFFFFF")

      if (row.type == "header"){
          backgroundColor = ColorHelper.hexToRGB("#D4D4D4")
      }

      if (row.type == "content"){
          backgroundColor = ColorHelper.hexToRGB("#F1F1F1")
      }

      if (row.color) color = ColorHelper.hexToRGB(row.color)
      if (row.backgroundColor) backgroundColor = ColorHelper.hexToRGB(row.backgroundColor)

      let request = {
          repeatCell: {
              range: {
                  sheetId: sheetId,
                  startRowIndex: i + y,
                  endRowIndex: i + y + 1,
                  startColumnIndex: 1,
                  endColumnIndex: width + 1
              },
              cell: {
                  userEnteredFormat: {
                      backgroundColor: backgroundColor,
                      textFormat: {
                          foregroundColor: color,
                          fontSize: fontSize,
                          bold: bold
                      }
                  }
              },
              fields: "userEnteredFormat(backgroundColor, textFormat)"
          }
      }

      requests.push(request)

      return Promise.resolve()
    }))

    await Promise.all(columns.map(async (column, i) => {
      let color, backgroundColor;
      let {bold = false, fontSize = 10} = column
      color = ColorHelper.hexToRGB("#000000")
      backgroundColor = ColorHelper.hexToRGB("#FFFFFF")

      if (column.type == "header"){
          backgroundColor = ColorHelper.hexToRGB("#D4D4D4")
      }

      if (column.type == "content"){
          backgroundColor = ColorHelper.hexToRGB("#F1F1F1")
      }

      if (column.color) color = ColorHelper.hexToRGB(column.color)
      if (column.backgroundColor) backgroundColor = ColorHelper.hexToRGB(column.backgroundColor)

      let request = {
          repeatCell: {
              range: {
                  sheetId: sheetId,
                  startRowIndex: y,
                  endRowIndex: y + height - 2,
                  startColumnIndex: i + 1,
                  endColumnIndex: i + 2
              },
              cell: {
                  userEnteredFormat: {
                      backgroundColor: backgroundColor,
                      textFormat: {
                          foregroundColor: color,
                          fontSize: fontSize,
                          bold: bold
                      }
                  }
              },
              fields: "userEnteredFormat(backgroundColor, textFormat)"
          }
      }

      requests.push(request)
  }))

  await this.update(spreadsheet, {
      requests
  })

  return spreadsheet
}

SheetHelper.prototype.writeRow = function (spreadsheet, config = {}) {
    let {
        spreadsheetId
    } = spreadsheet
    let {
        values,
        y = 1
    } = config

    return gapi.client.sheets.spreadsheets.values.update({
        spreadsheetId: spreadsheetId,
        range: `B${y}`,
        valueInputOption: "USER_ENTERED",
        resource: {
            values: [
                values
            ]
        }
    }, {}).then((response) => {
        return response.result
    });
}

SheetHelper.prototype.writeRows = function (spreadsheet, config = {}){
    let {
        spreadsheetId
    } = spreadsheet
    let {
        values,
        y = 1
    } = config

    return gapi.client.sheets.spreadsheets.values.update({
        spreadsheetId: spreadsheetId,
        range: `B${y}`,
        valueInputOption: "USER_ENTERED",
        resource: {
            values
        }
    }, {}).then((response) => {
        return response.result
    }).catch(console.error);
}


export default new SheetHelper()



// WEBPACK FOOTER //
// ./src/components/export-google-sheet/helpers/sheet/index.js